// extracted by mini-css-extract-plugin
module.exports = {"cookiesFooter":"CookiesFooter_cookiesFooter__01Al5","centerCookiesFooter":"CookiesFooter_centerCookiesFooter__e3vIL","button":"CookiesFooter_button__l_Uzv"};